export const mitrexCalculatorData = {
  master_parameters: {
    energy_kwh: 1000,
    cars_per_year: 0.153,
    metric_tonnes_co2_per_year: 0.707,
    electricity_homes_per_year: 0.12,
    acres_of_forest_per_year: 461.5
  },
  building_types: {
    residential_building: {
      image: "https://camas.app/resources/static/images/images/image__737ca0602115f16bb0a2d42c840e8567.png",
      label: "Residential Building",
      subtypes: {
        two_tower_highrise: {
          image: "https://camas.app/resources/static/images/images/image__44904e2b72e990d27c5c3f6914e5cf36.png",
          label: "Two Tower High-Rise",
          storeys: 30,
          is_subtype: true,
          default_size: {
            cladding: {
              "north": 25000,
              "south": 25000,
              "east": 25000,
              "west": 25000
            },
            window: {
              "north":  37500,
              "south": 37500,
              "east": 37500,
              "west": 37500
            },
            railing: {
              "north": 4300,
              "south": 4300,
              "east": 4300,
              "west": 4300
            }
          }
        },
        single_tower_highrise: {
          image: "https://camas.app/resources/static/images/images/image__737ca0602115f16bb0a2d42c840e8567.png",
          label: "Single Tower High-Rise",
          is_subtype: true,
          default_size: {
            cladding: {
              "north": 13750,
              "south": 13750,
              "east": 13750,
              "west": 13750
            },
            window: {
              "north": 22700,
              "south": 22700,
              "east": 22700,
              "west": 22700
            },
            railing: {
              "north": 2150,
              "south": 2150,
              "east": 2150,
              "west": 2150
            }
          }
        },
        midrise: {
          image: "https://camas.app/resources/static/images/images/image__b2a3fda3e03da0bdb208ee3113a31e3a.png",
          label: "Mid-Rise",
          storeys: 20,
          is_subtype: true,
          default_size: {
            cladding: {
              "north": 8750,
              "south": 8750,
              "east": 8750,
              "west": 8750
            },
            window: {
              "north":  13125,
              "south": 13125,
              "east": 13125,
              "west": 13125
            },
            railing: {
              "north": 1505,
              "south": 1505,
              "east": 1505,
              "west": 1505
            }
          }
        },
        lowrise: {
          image: "https://camas.app/resources/static/images/images/image__994d988314cc8e96d9251340826bc7ba.png",
          label: "Low-Rise",
          storeys: 10,
          is_subtype: true,
          default_size: {
            cladding: {
              "north": 2500,
              "south": 2500,
              "east": 2500,
              "west": 2500
            },
            window: {
              "north":  3750,
              "south": 3750,
              "east": 3750,
              "west": 3750
            },
            railing: {
              "north": 430,
              "south": 430,
              "east": 430,
              "west": 430
            }
          }
        }
      }
    },
    office_building: {
      image: "https://camas.app/resources/static/images/images/image__00ddfdc3343581b5815ab89f21717878.png",
      label: "Office Building",
      subtypes: {
        two_tower_highrise: {
          image: "https://camas.app/resources/static/images/images/image__e46eb0dc94b3a0d71bd9ce7152ec8904.png",
          label: "Two Tower High-Rise",
          storeys: 30,
          is_subtype: true,
          default_size: {
            cladding: {
              "north": 25000,
              "south": 25000,
              "east": 25000,
              "west": 25000
            },
            window: {
              "north":  37500,
              "south": 37500,
              "east": 37500,
              "west": 37500
            },
            railing: {
              "north": 4300,
              "south": 4300,
              "east": 4300,
              "west": 4300
            }
          }
        },
        single_tower_highrise: {
          image: "https://camas.app/resources/static/images/images/image__00ddfdc3343581b5815ab89f21717878.png",
          label: "Single Tower High-Rise",
          is_subtype: true,
          default_size: {
            cladding: {
              "north": 13750,
              "south": 13750,
              "east": 13750,
              "west": 13750
            },
            window: {
              "north": 22700,
              "south": 22700,
              "east": 22700,
              "west": 22700
            },
            railing: {
              "north": 2150,
              "south": 2150,
              "east": 2150,
              "west": 2150
            }
          }
        },
        midrise: {
          image: "https://camas.app/resources/static/images/images/image__f4e4bdd0a73754121bfc1eb3c0f860a6.png",
          label: "Mid-Rise",
          storeys: 20,
          is_subtype: true,
          default_size: {
            cladding: {
              "north": 8750,
              "south": 8750,
              "east": 8750,
              "west": 8750
            },
            window: {
              "north":  13125,
              "south": 13125,
              "east": 13125,
              "west": 13125
            },
            railing: {
              "north": 1505,
              "south": 1505,
              "east": 1505,
              "west": 1505
            }
          }
        },
        lowrise: {
          image: "https://camas.app/resources/static/images/images/image__0b0c2fd8673cfb72da29eec3646a1d6a.png",
          label: "Low-Rise",
          storeys: 10,
          is_subtype: true,
          default_size: {
            cladding: {
              "north": 2500,
              "south": 2500,
              "east": 2500,
              "west": 2500
            },
            window: {
              "north":  3750,
              "south": 3750,
              "east": 3750,
              "west": 3750
            },
            railing: {
              "north": 430,
              "south": 430,
              "east": 430,
              "west": 430
            }
          }
        }
      }
    },
    greenhouse: {
      image: "https://camas.app/resources/static/images/images/image__7231439b7e20117422d6492d77699b17.png",
      label: "Greenhouse",
      storeys: null,
      default_size: {
        window: {
          "north": 7500,
          "south": 7500,
          "east": 7500,
          "west": 7500
        }
      }
    },
    data_centre: {
      image: "https://camas.app/resources/static/images/images/image__88ecd60fa9f6b9d2823f9abe82c6382d.png",
      label: "Data Centre",
      storeys: null,
      default_size: {
        cladding: {
          "north": 7000,
          "south": 7000,
          "east": 7000,
          "west": 7000
        }
      }
    }
  },
  products: {
    cladding: {
      "ardea": {
        "sample_type": "Brick",
        "sample_name": "Ardea",
        image: "https://camas.app/resources/static/images/images/image__561c497c7e275c46703bf7a1d7eaa664.png",
        "watt_sqft": 3.6,
        "mpa_price": 39,
        "dpa_price": 63
      },
      "calcaria": {
        "sample_type": "Brick",
        "sample_name": "Calcaria",
        image: "https://camas.app/resources/static/images/images/image__d246d6ddf0eb64e11ad7c02396cf9d54.png",
        "watt_sqft": 3.1,
        "mpa_price": 41,
        "dpa_price": 61
      },
      "ferra": {
        "sample_type": "Brick",
        "sample_name": "Ferra",
        image: "https://camas.app/resources/static/images/images/image__e8ed80dbf984ecf854b1318142d740e4.png",
        "watt_sqft": 4.2,
        "mpa_price": 37,
        "dpa_price": 65
      },
      "oscuro": {
        "sample_type": "Brick",
        "sample_name": "Oscuro",
        image: "https://camas.app/resources/static/images/images/image__67b3f391b5093a5721d7cf8abd8fb927.png",
        "watt_sqft": 5.3,
        "mpa_price": 33,
        "dpa_price": 69
      },
      "rubrica": {
        "sample_type": "Brick",
        "sample_name": "Rubrica",
        image: "https://camas.app/resources/static/images/images/image__12ed3bed3cf15af8a1f6c53daf0ba394.png",
        "watt_sqft": 3.9,
        "mpa_price": 38,
        "dpa_price": 64
      },
      "angola": {
        "sample_type": "Granite",
        "sample_name": "Angola",
        image: "https://camas.app/resources/static/images/images/image__caea97dd79d797c044de49c5d913af08.png",
        "watt_sqft": 5.3,
        "mpa_price": 33,
        "dpa_price": 69
      },
      "carbo": {
        "sample_type": "Granite",
        "sample_name": "Carbo",
        image: "https://camas.app/resources/static/images/images/image__3fdba30e94b02bef28f896683c72c591.png",
        "watt_sqft": 5,
        "mpa_price": 34,
        "dpa_price": 68
      },
      "moonstone": {
        "sample_type": "Granite",
        "sample_name": "Moonstone",
        image: "https://camas.app/resources/static/images/images/image__bd6707c72498740ec4bfd4f5d3ee8a97.png",
        "watt_sqft": 3.3,
        "mpa_price": 40,
        "dpa_price": 62
      },
      "rosea": {
        "sample_type": "Granite",
        "sample_name": "Rosea",
        image: "https://camas.app/resources/static/images/images/image__af1bd09a19aa9c707f9c8022ab209ce0.png",
        "watt_sqft": 4.2,
        "mpa_price": 37,
        "dpa_price": 65
      },
      "ancona": {
        "sample_type": "Limestone",
        "sample_name": "Ancona",
        image: "https://camas.app/resources/static/images/images/image__f69d3d12963d9fca24968d49e29f8025.png",
        "watt_sqft": 5,
        "mpa_price": 34,
        "dpa_price": 68
      },
      "arcturus": {
        "sample_type": "Limestone",
        "sample_name": "Arcturus",
        image: "https://camas.app/resources/static/images/images/image__7bbbf1f308a0b7533d3a9d842b4c90b3.png",
        "watt_sqft": 3.1,
        "mpa_price": 41,
        "dpa_price": 61
      },
      "elara": {
        "sample_type": "Limestone",
        "sample_name": "Elara",
        image: "https://camas.app/resources/static/images/images/image__c7cd027db7a518de14c5570d65619bb0.png",
        "watt_sqft": 4.7,
        "mpa_price": 35,
        "dpa_price": 67
      },
      "fennec": {
        "sample_type": "Limestone",
        "sample_name": "Fennec",
        image: "https://camas.app/resources/static/images/images/image__97246209d1c6a04212a188318ef14fbd.png",
        "watt_sqft": 3.6,
        "mpa_price": 39,
        "dpa_price": 63
      },
      "selene": {
        "sample_type": "Limestone",
        "sample_name": "Selene",
        image: "https://camas.app/resources/static/images/images/image__0e62edae86ba3b2cc9b3cf822a4d2f4c.png",
        "watt_sqft": 4.2,
        "mpa_price": 37,
        "dpa_price": 65
      },
      "aurora": {
        "sample_type": "Marble",
        "sample_name": "Aurora",
        image: "https://camas.app/resources/static/images/images/image__ff90287dbf262b8e2b59587e42de3409.png",
        "watt_sqft": 3.1,
        "mpa_price": 41,
        "dpa_price": 61
      },
      "fumo": {
        "sample_type": "Marble",
        "sample_name": "Fumo",
        image: "https://camas.app/resources/static/images/images/image__6683244e42d75dd56c96cdcc57d089d9.png",
        "watt_sqft": 4.4,
        "mpa_price": 36,
        "dpa_price": 66
      },
      "ionian": {
        "sample_type": "Marble",
        "sample_name": "Ionian",
        image: "https://camas.app/resources/static/images/images/image__13885594da702da5d5e98dd8289874fd.png",
        "watt_sqft": 4.4,
        "mpa_price": 37,
        "dpa_price": 65
      },
      "orbit": {
        "sample_type": "Marble",
        "sample_name": "Orbit",
        image: "https://camas.app/resources/static/images/images/image__9a8c48b35bf0ca993f1c87316a6fb475.png",
        "watt_sqft": 5.6,
        "mpa_price": 32,
        "dpa_price": 70
      },
      "snowfall": {
        "sample_type": "Marble",
        "sample_name": "Snowfall",
        image: "https://camas.app/resources/static/images/images/image__d727e72f3465bfeee92f1738a33b237b.png",
        "watt_sqft": 3.6,
        "mpa_price": 39,
        "dpa_price": 63
      },
      "venula": {
        "sample_type": "Marble",
        "sample_name": "Venula",
        image: "https://camas.app/resources/static/images/images/image__cecb74811b7c44d648e6206d5cf4d1c3.png",
        "watt_sqft": 5,
        "mpa_price": 34,
        "dpa_price": 68
      },
      "cassia": {
        "sample_type": "Metal",
        "sample_name": "Cassia",
        image: "https://camas.app/resources/static/images/images/image__f4064a2ba3fc230d0efdbc47084fb696.png",
        "watt_sqft": 4.4,
        "mpa_price": 36,
        "dpa_price": 66
      },
      "cobaltic": {
        "sample_type": "Metal",
        "sample_name": "Cobaltic",
        image: "https://camas.app/resources/static/images/images/image__81f0316c57c3fe6c7f8f7e4db0241d2c.png",
        "watt_sqft": 4.2,
        "mpa_price": 37,
        "dpa_price": 65
      },
      "falco": {
        "sample_type": "Metal",
        "sample_name": "Falco",
        image: "https://camas.app/resources/static/images/images/image__13b9535f7b3701b556e714aab2e7c620.png",
        "watt_sqft": 3.6,
        "mpa_price": 39,
        "dpa_price": 63
      },
      "caldera": {
        "sample_type": "Slate",
        "sample_name": "Caldera",
        image: "https://camas.app/resources/static/images/images/image__8c0dbae024de3a32b22d46180a0528da.png",
        "watt_sqft": 4.4,
        "mpa_price": 36,
        "dpa_price": 66
      },
      "corvus": {
        "sample_type": "Slate",
        "sample_name": "Corvus",
        image: "https://camas.app/resources/static/images/images/image__06d9d65638de226c7492c2638834bb7a.png",
        "watt_sqft": 5,
        "mpa_price": 34,
        "dpa_price": 68
      },
      "montanea": {
        "sample_type": "Slate",
        "sample_name": "Montanea",
        image: "https://camas.app/resources/static/images/images/image__b46d897a79795a8d42b65450c649aa39.png",
        "watt_sqft": 5.3,
        "mpa_price": 33,
        "dpa_price": 69
      },
      "cinnabar": {
        "sample_type": "Solid",
        "sample_name": "Cinnabar",
        image: "https://camas.app/resources/static/images/images/image__8be298d94a203051a6faef02e6cc16d8.png",
        "watt_sqft": 3.3,
        "mpa_price": 40,
        "dpa_price": 62
      },
      "limunada": {
        "sample_type": "Solid",
        "sample_name": "Limunada",
        image: "https://camas.app/resources/static/images/images/image__b44026900bdcfaecc0f896ba63dbfd2e.png",
        "watt_sqft": 3.1,
        "mpa_price": 41,
        "dpa_price": 61
      },
      "morpho": {
        "sample_type": "Solid",
        "sample_name": "Morpho",
        image: "https://camas.app/resources/static/images/images/image__dac46883a1735794eb65c71530e0fe60.png",
        "watt_sqft": 4.2,
        "mpa_price": 37,
        "dpa_price": 65
      },
      "obsidian": {
        "sample_type": "Solid",
        "sample_name": "Obsidian",
        image: "https://camas.app/resources/static/images/images/image__19d7a8c96031ed559dd16e1024188431.png",
        "watt_sqft": 5.6,
        "mpa_price": 32,
        "dpa_price": 70
      },
      "peridot": {
        "sample_type": "Solid",
        "sample_name": "Peridot",
        image: "https://camas.app/resources/static/images/images/image__029515a4980fc34413fc1f2ca8d231cc.png",
        "watt_sqft": 2.8,
        "mpa_price": 42,
        "dpa_price": 60
      },
      "chantilly": {
        "sample_type": "Wood",
        "sample_name": "Chantilly",
        image: "https://camas.app/resources/static/images/images/image__927e88f731ad1461a9b03611cf8e847d.png",
        "watt_sqft": 4.2,
        "mpa_price": 37,
        "dpa_price": 65
      },
      "charbon": {
        "sample_type": "Wood",
        "sample_name": "Charbon",
        image: "https://camas.app/resources/static/images/images/image__70695eac1dc554dc984b33af7068cad1.png",
        "watt_sqft": 5,
        "mpa_price": 34,
        "dpa_price": 68
      },
      "cinis": {
        "sample_type": "Wood",
        "sample_name": "Cinis",
        image: "https://camas.app/resources/static/images/images/image__6e890c33681e0b090b27935d6bb64135.png",
        "watt_sqft": 4.7,
        "mpa_price": 35,
        "dpa_price": 67
      },
      "filigrana": {
        "sample_type": "Wood",
        "sample_name": "Filigrana",
        image: "https://camas.app/resources/static/images/images/image__c5ef6d2d293015097e82525958941352.png",
        "watt_sqft": 4.2,
        "mpa_price": 37,
        "dpa_price": 65
      },
      "mandorla": {
        "sample_type": "Wood",
        "sample_name": "Mandorla",
        image: "https://camas.app/resources/static/images/images/image__46695a6b2f83a64c022d139a14521c7b.png",
        "watt_sqft": 3.6,
        "mpa_price": 39,
        "dpa_price": 63
      }
    },
    railing: {
      "transparent": {
        "sample_name": "Transparent",
        image: "https://camas.app/resources/static/images/images/image__e91a1b9a2efa1530039a640e5e9c1660.jpg",
        "watt_lft": 13.6,
        "mpa_price": 120,
        "dpa_price": 150
      },
      "semi_opaque": {
        "sample_name": "Semi-Opaque",
        image: "https://camas.app/resources/static/images/images/image__4f526cbf5ad0e7a5b05e44ffc061c7cc.jpg",
        "watt_lft": 25.5,
        "mpa_price": 120,
        "dpa_price": 150
      },
      "semi_transparent": {
        "sample_name": "Semi-Transparent",
        image: "https://camas.app/resources/static/images/images/image__2e2145da324762b5918a6c13a182d057.jpg",
        "watt_lft": 34,
        "mpa_price": 120,
        "dpa_price": 150
      }
    },
    window: {
      "transparent": {
        "sample_name": "Transparent",
        image: "https://camas.app/resources/static/images/images/image__b57378f8c31fd524e5c80dcf329b8f3b.jpg",
        "watt_sqft": 4,
        "mpa_price": 65,
        "dpa_price": 75
      },
      "semi_opaque": {
        "sample_name": "Semi-Opaque",
        image: "https://camas.app/resources/static/images/images/image__4a95ca734b8c9bf19e547aee9616d4e1.jpg",
        "watt_sqft": 7.5,
        "mpa_price": 65,
        "dpa_price": 75
      },
      "semi_transparent": {
        "sample_name": "Semi-Transparent",
        image: "https://camas.app/resources/static/images/images/image__203f991238b8942aa4d5069b87694efc.jpg",
        "watt_sqft": 10,
        "mpa_price": 65,
        "dpa_price": 75
      }
    }
  },
  location: "https://camas.app/resources/static/images/images/image__b463ec5fe7f67aa68fb99b0bc72b84b5.svg",
  sunlight_hours: {
    "alberta": {
      "location": "Alberta",
      "electricity_price_kwh": 0.17,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.14,
      "south_sunlight_hours": 1158,
      "west_sunlight_hours": 777,
      "east_sunlight_hours": 800,
      "north_sunlight_hours": 329,
      "average_sunlight": 766
    },
    "british_columbia": {
      "location": "British Columbia",
      "electricity_price_kwh": 0.12,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.09,
      "south_sunlight_hours": 780,
      "west_sunlight_hours": 634,
      "east_sunlight_hours": 639,
      "north_sunlight_hours": 314,
      "average_sunlight": 592
    },
    "manitoba": {
      "location": "Manitoba",
      "electricity_price_kwh": 0.1,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.07,
      "south_sunlight_hours": 1146,
      "west_sunlight_hours": 765,
      "east_sunlight_hours": 788,
      "north_sunlight_hours": 328,
      "average_sunlight": 757
    },
    "new_brunswick": {
      "location": "New Brunswick",
      "electricity_price_kwh": 0.13,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.1,
      "south_sunlight_hours": 902,
      "west_sunlight_hours": 667,
      "east_sunlight_hours": 671,
      "north_sunlight_hours": 323,
      "average_sunlight": 641
    },
    "newfoundland_and_labrador": {
      "location": "Newfoundland and Labrador",
      "electricity_price_kwh": 0.14,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.11,
      "south_sunlight_hours": 782,
      "west_sunlight_hours": 617,
      "east_sunlight_hours": 594,
      "north_sunlight_hours": 316,
      "average_sunlight": 577
    },
    "northwest_territories": {
      "location": "Northwest Territories",
      "electricity_price_kwh": 0.39,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.36,
      "south_sunlight_hours": 1040,
      "west_sunlight_hours": 705,
      "east_sunlight_hours": 699,
      "north_sunlight_hours": 305,
      "average_sunlight": 687
    },
    "nova_scotia": {
      "location": "Nova Scotia",
      "electricity_price_kwh": 0.15,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.12,
      "south_sunlight_hours": 834,
      "west_sunlight_hours": 643,
      "east_sunlight_hours": 656,
      "north_sunlight_hours": 326,
      "average_sunlight": 615
    },
    "nunavut": {
      "location": "Nunavut",
      "electricity_price_kwh": 0.37,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.34,
      "south_sunlight_hours": 1008,
      "west_sunlight_hours": 677,
      "east_sunlight_hours": 673,
      "north_sunlight_hours": 295,
      "average_sunlight": 663
    },
    "ontario": {
      "location": "Ontario",
      "electricity_price_kwh": 0.12,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.09,
      "south_sunlight_hours": 893,
      "west_sunlight_hours": 684,
      "east_sunlight_hours": 691,
      "north_sunlight_hours": 334,
      "average_sunlight": 650
    },
    "prince_edward_island": {
      "location": "Prince Edward Island",
      "electricity_price_kwh": 0.17,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.14,
      "south_sunlight_hours": 865,
      "west_sunlight_hours": 661,
      "east_sunlight_hours": 671,
      "north_sunlight_hours": 328,
      "average_sunlight": 631
    },
    "quebec": {
      "location": "Quebec",
      "electricity_price_kwh": 0.07,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.04,
      "south_sunlight_hours": 929,
      "west_sunlight_hours": 677,
      "east_sunlight_hours": 690,
      "north_sunlight_hours": 329,
      "average_sunlight": 656
    },
    "saskatchewan": {
      "location": "Saskatchewan",
      "electricity_price_kwh": 0.18,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.15,
      "south_sunlight_hours": 1185,
      "west_sunlight_hours": 792,
      "east_sunlight_hours": 806,
      "north_sunlight_hours": 331,
      "average_sunlight": 779
    },
    "yukon_territories": {
      "location": "Yukon Territories",
      "electricity_price_kwh": 0.14,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.11,
      "south_sunlight_hours": 933,
      "west_sunlight_hours": 631,
      "east_sunlight_hours": 648,
      "north_sunlight_hours": 286,
      "average_sunlight": 625
    },
    "alabama": {
      "location": "Alabama",
      "electricity_price_kwh": 0.17,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.14,
      "south_sunlight_hours": 916,
      "west_sunlight_hours": 775,
      "east_sunlight_hours": 792,
      "north_sunlight_hours": 381,
      "average_sunlight": 716
    },
    "alaska": {
      "location": "Alaska",
      "electricity_price_kwh": 0.32,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.29,
      "south_sunlight_hours": 728,
      "west_sunlight_hours": 482,
      "east_sunlight_hours": 478,
      "north_sunlight_hours": 250,
      "average_sunlight": 485
    },
    "arizona": {
      "location": "Arizona",
      "electricity_price_kwh": 0.17,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.14,
      "south_sunlight_hours": 1124,
      "west_sunlight_hours": 935,
      "east_sunlight_hours": 966,
      "north_sunlight_hours": 369,
      "average_sunlight": 849
    },
    "arkansas": {
      "location": "Arkansas",
      "electricity_price_kwh": 0.14,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.11,
      "south_sunlight_hours": 901,
      "west_sunlight_hours": 780,
      "east_sunlight_hours": 758,
      "north_sunlight_hours": 367,
      "average_sunlight": 702
    },
    "california": {
      "location": "California",
      "electricity_price_kwh": 0.25,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.22,
      "south_sunlight_hours": 1009,
      "west_sunlight_hours": 852,
      "east_sunlight_hours": 882,
      "north_sunlight_hours": 378,
      "average_sunlight": 780
    },
    "colorado": {
      "location": "Colorado",
      "electricity_price_kwh": 0.17,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.14,
      "south_sunlight_hours": 1105,
      "west_sunlight_hours": 828,
      "east_sunlight_hours": 891,
      "north_sunlight_hours": 371,
      "average_sunlight": 799
    },
    "connecticut": {
      "location": "Connecticut",
      "electricity_price_kwh": 0.21,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.18,
      "south_sunlight_hours": 911,
      "west_sunlight_hours": 703,
      "east_sunlight_hours": 693,
      "north_sunlight_hours": 344,
      "average_sunlight": 663
    },
    "delaware": {
      "location": "Delaware",
      "electricity_price_kwh": 0.16,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.13,
      "south_sunlight_hours": 914,
      "west_sunlight_hours": 713,
      "east_sunlight_hours": 742,
      "north_sunlight_hours": 361,
      "average_sunlight": 683
    },
    "florida": {
      "location": "Florida",
      "electricity_price_kwh": 0.16,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.13,
      "south_sunlight_hours": 838,
      "west_sunlight_hours": 763,
      "east_sunlight_hours": 790,
      "north_sunlight_hours": 397,
      "average_sunlight": 697
    },
    "georgia": {
      "location": "Georgia",
      "electricity_price_kwh": 0.17,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.14,
      "south_sunlight_hours": 925,
      "west_sunlight_hours": 795,
      "east_sunlight_hours": 809,
      "north_sunlight_hours": 385,
      "average_sunlight": 729
    },
    "hawaii": {
      "location": "Hawaii",
      "electricity_price_kwh": 0.38,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.35,
      "south_sunlight_hours": 803,
      "west_sunlight_hours": 841,
      "east_sunlight_hours": 845,
      "north_sunlight_hours": 433,
      "average_sunlight": 731
    },
    "idaho": {
      "location": "Idaho",
      "electricity_price_kwh": 0.14,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.11,
      "south_sunlight_hours": 1031,
      "west_sunlight_hours": 827,
      "east_sunlight_hours": 835,
      "north_sunlight_hours": 351,
      "average_sunlight": 761
    },
    "illinois": {
      "location": "Illinois",
      "electricity_price_kwh": 0.16,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.13,
      "south_sunlight_hours": 921,
      "west_sunlight_hours": 729,
      "east_sunlight_hours": 736,
      "north_sunlight_hours": 357,
      "average_sunlight": 685
    },
    "indiana": {
      "location": "Indiana",
      "electricity_price_kwh": 0.16,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.13,
      "south_sunlight_hours": 920,
      "west_sunlight_hours": 743,
      "east_sunlight_hours": 756,
      "north_sunlight_hours": 357,
      "average_sunlight": 694
    },
    "iowa": {
      "location": "Iowa",
      "electricity_price_kwh": 0.19,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.16,
      "south_sunlight_hours": 1014,
      "west_sunlight_hours": 766,
      "east_sunlight_hours": 791,
      "north_sunlight_hours": 353,
      "average_sunlight": 731
    },
    "kansas": {
      "location": "Kansas",
      "electricity_price_kwh": 0.17,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.14,
      "south_sunlight_hours": 1001,
      "west_sunlight_hours": 775,
      "east_sunlight_hours": 797,
      "north_sunlight_hours": 355,
      "average_sunlight": 732
    },
    "kentucky": {
      "location": "Kentucky",
      "electricity_price_kwh": 0.14,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.11,
      "south_sunlight_hours": 880,
      "west_sunlight_hours": 710,
      "east_sunlight_hours": 728,
      "north_sunlight_hours": 358,
      "average_sunlight": 669
    },
    "louisiana": {
      "location": "Louisiana",
      "electricity_price_kwh": 0.12,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.09,
      "south_sunlight_hours": 831,
      "west_sunlight_hours": 733,
      "east_sunlight_hours": 754,
      "north_sunlight_hours": 375,
      "average_sunlight": 673
    },
    "maine": {
      "location": "Maine",
      "electricity_price_kwh": 0.22,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.19,
      "south_sunlight_hours": 923,
      "west_sunlight_hours": 679,
      "east_sunlight_hours": 683,
      "north_sunlight_hours": 327,
      "average_sunlight": 653
    },
    "maryland": {
      "location": "Maryland",
      "electricity_price_kwh": 0.16,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.13,
      "south_sunlight_hours": 908,
      "west_sunlight_hours": 715,
      "east_sunlight_hours": 741,
      "north_sunlight_hours": 355,
      "average_sunlight": 680
    },
    "massachusetts": {
      "location": "Massachusetts",
      "electricity_price_kwh": 0.26,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.23,
      "south_sunlight_hours": 946,
      "west_sunlight_hours": 716,
      "east_sunlight_hours": 724,
      "north_sunlight_hours": 345,
      "average_sunlight": 683
    },
    "michigan": {
      "location": "Michigan",
      "electricity_price_kwh": 0.22,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.19,
      "south_sunlight_hours": 845,
      "west_sunlight_hours": 673,
      "east_sunlight_hours": 681,
      "north_sunlight_hours": 340,
      "average_sunlight": 635
    },
    "minnesota": {
      "location": "Minnesota",
      "electricity_price_kwh": 0.18,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.15,
      "south_sunlight_hours": 993,
      "west_sunlight_hours": 723,
      "east_sunlight_hours": 758,
      "north_sunlight_hours": 335,
      "average_sunlight": 702
    },
    "mississippi": {
      "location": "Mississippi",
      "electricity_price_kwh": 0.14,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.11,
      "south_sunlight_hours": 893,
      "west_sunlight_hours": 768,
      "east_sunlight_hours": 791,
      "north_sunlight_hours": 377,
      "average_sunlight": 707
    },
    "missouri": {
      "location": "Missouri",
      "electricity_price_kwh": 0.17,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.14,
      "south_sunlight_hours": 963,
      "west_sunlight_hours": 758,
      "east_sunlight_hours": 782,
      "north_sunlight_hours": 361,
      "average_sunlight": 716
    },
    "montana": {
      "location": "Montana",
      "electricity_price_kwh": 0.16,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.13,
      "south_sunlight_hours": 1035,
      "west_sunlight_hours": 787,
      "east_sunlight_hours": 773,
      "north_sunlight_hours": 341,
      "average_sunlight": 734
    },
    "nebraska": {
      "location": "Nebraska",
      "electricity_price_kwh": 0.15,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.12,
      "south_sunlight_hours": 970,
      "west_sunlight_hours": 749,
      "east_sunlight_hours": 783,
      "north_sunlight_hours": 354,
      "average_sunlight": 714
    },
    "nevada": {
      "location": "Nevada",
      "electricity_price_kwh": 0.14,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.11,
      "south_sunlight_hours": 1180,
      "west_sunlight_hours": 934,
      "east_sunlight_hours": 973,
      "north_sunlight_hours": 360,
      "average_sunlight": 862
    },
    "new_hampshire": {
      "location": "New Hampshire",
      "electricity_price_kwh": 0.24,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.21,
      "south_sunlight_hours": 942,
      "west_sunlight_hours": 714,
      "east_sunlight_hours": 719,
      "north_sunlight_hours": 343,
      "average_sunlight": 680
    },
    "new_jersey": {
      "location": "New Jersey",
      "electricity_price_kwh": 0.22,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.19,
      "south_sunlight_hours": 919,
      "west_sunlight_hours": 712,
      "east_sunlight_hours": 726,
      "north_sunlight_hours": 355,
      "average_sunlight": 678
    },
    "new_mexico": {
      "location": "New Mexico",
      "electricity_price_kwh": 0.18,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.15,
      "south_sunlight_hours": 1214,
      "west_sunlight_hours": 983,
      "east_sunlight_hours": 1030,
      "north_sunlight_hours": 411,
      "average_sunlight": 910
    },
    "new_york": {
      "location": "New York",
      "electricity_price_kwh": 0.19,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.16,
      "south_sunlight_hours": 907,
      "west_sunlight_hours": 704,
      "east_sunlight_hours": 718,
      "north_sunlight_hours": 347,
      "average_sunlight": 669
    },
    "north_carolina": {
      "location": "North Carolina",
      "electricity_price_kwh": 0.15,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.12,
      "south_sunlight_hours": 919,
      "west_sunlight_hours": 746,
      "east_sunlight_hours": 767,
      "north_sunlight_hours": 366,
      "average_sunlight": 700
    },
    "north_dakota": {
      "location": "North Dakota",
      "electricity_price_kwh": 0.16,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.13,
      "south_sunlight_hours": 1039,
      "west_sunlight_hours": 751,
      "east_sunlight_hours": 762,
      "north_sunlight_hours": 336,
      "average_sunlight": 722
    },
    "ohio": {
      "location": "Ohio",
      "electricity_price_kwh": 0.16,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.13,
      "south_sunlight_hours": 848,
      "west_sunlight_hours": 689,
      "east_sunlight_hours": 703,
      "north_sunlight_hours": 346,
      "average_sunlight": 646
    },
    "oklahoma": {
      "location": "Oklahoma",
      "electricity_price_kwh": 0.13,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.1,
      "south_sunlight_hours": 985,
      "west_sunlight_hours": 816,
      "east_sunlight_hours": 821,
      "north_sunlight_hours": 373,
      "average_sunlight": 749
    },
    "oregon": {
      "location": "Oregon",
      "electricity_price_kwh": 0.15,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.12,
      "south_sunlight_hours": 822,
      "west_sunlight_hours": 640,
      "east_sunlight_hours": 661,
      "north_sunlight_hours": 321,
      "average_sunlight": 611
    },
    "pennsylvania": {
      "location": "Pennsylvania",
      "electricity_price_kwh": 0.18,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.15,
      "south_sunlight_hours": 893,
      "west_sunlight_hours": 702,
      "east_sunlight_hours": 724,
      "north_sunlight_hours": 350,
      "average_sunlight": 667
    },
    "rhode_island": {
      "location": "Rhode Island",
      "electricity_price_kwh": 0.25,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.22,
      "south_sunlight_hours": 929,
      "west_sunlight_hours": 712,
      "east_sunlight_hours": 697,
      "north_sunlight_hours": 344,
      "average_sunlight": 671
    },
    "south_carolina": {
      "location": "South Carolina",
      "electricity_price_kwh": 0.16,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.13,
      "south_sunlight_hours": 938,
      "west_sunlight_hours": 800,
      "east_sunlight_hours": 809,
      "north_sunlight_hours": 389,
      "average_sunlight": 734
    },
    "south_dakota": {
      "location": "South Dakota",
      "electricity_price_kwh": 0.16,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.13,
      "south_sunlight_hours": 1057,
      "west_sunlight_hours": 767,
      "east_sunlight_hours": 803,
      "north_sunlight_hours": 343,
      "average_sunlight": 743
    },
    "tennessee": {
      "location": "Tennessee",
      "electricity_price_kwh": 0.14,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.11,
      "south_sunlight_hours": 891,
      "west_sunlight_hours": 743,
      "east_sunlight_hours": 766,
      "north_sunlight_hours": 367,
      "average_sunlight": 692
    },
    "texas": {
      "location": "Texas",
      "electricity_price_kwh": 0.16,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.13,
      "south_sunlight_hours": 877,
      "west_sunlight_hours": 792,
      "east_sunlight_hours": 816,
      "north_sunlight_hours": 395,
      "average_sunlight": 720
    },
    "utah": {
      "location": "Utah",
      "electricity_price_kwh": 0.15,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.12,
      "south_sunlight_hours": 1053,
      "west_sunlight_hours": 848,
      "east_sunlight_hours": 862,
      "north_sunlight_hours": 362,
      "average_sunlight": 781
    },
    "vermont": {
      "location": "Vermont",
      "electricity_price_kwh": 0.22,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.19,
      "south_sunlight_hours": 911,
      "west_sunlight_hours": 705,
      "east_sunlight_hours": 692,
      "north_sunlight_hours": 342,
      "average_sunlight": 663
    },
    "virginia": {
      "location": "Virginia",
      "electricity_price_kwh": 0.16,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.13,
      "south_sunlight_hours": 947,
      "west_sunlight_hours": 757,
      "east_sunlight_hours": 759,
      "north_sunlight_hours": 364,
      "average_sunlight": 707
    },
    "washington": {
      "location": "Washington",
      "electricity_price_kwh": 0.13,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.1,
      "south_sunlight_hours": 769,
      "west_sunlight_hours": 629,
      "east_sunlight_hours": 614,
      "north_sunlight_hours": 308,
      "average_sunlight": 580
    },
    "west_virginia": {
      "location": "West Virginia",
      "electricity_price_kwh": 0.15,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.12,
      "south_sunlight_hours": 868,
      "west_sunlight_hours": 720,
      "east_sunlight_hours": 728,
      "north_sunlight_hours": 354,
      "average_sunlight": 668
    },
    "wisconsin": {
      "location": "Wisconsin",
      "electricity_price_kwh": 0.19,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.16,
      "south_sunlight_hours": 942,
      "west_sunlight_hours": 728,
      "east_sunlight_hours": 719,
      "north_sunlight_hours": 343,
      "average_sunlight": 683
    },
    "wyoming": {
      "location": "Wyoming",
      "electricity_price_kwh": 0.16,
      "customer_share_dollars": 0.03,
      "mitrex_share_dollars": 0.13,
      "south_sunlight_hours": 1080,
      "west_sunlight_hours": 818,
      "east_sunlight_hours": 862,
      "north_sunlight_hours": 376,
      "average_sunlight": 784
    }
  },
  tax_incentives: [
    {
      "key": "prince_edward_island",
      "location": "Prince Edward Island",
      "name": "Canadian Federal Tax Incentives",
      "link": "https://www.canada.ca/en/revenue-agency/services/tax/technical-information/income-tax/income-tax-folios-index/series-3-property-investments-savings-plans/series-3-property-investments-savings-plan-folio-8-resource-properties/income-tax-folio-s3-f8-c2-tax-incentives-clean-energy-equipment.html"
    },
    {
      "key": "prince_edward_island",
      "location": "Prince Edward Island",
      "name": "Solar Rebate Program",
      "link": "https://www.princeedwardisland.ca/en/information/transportation-infrastructure-and-energy/solar-electric-rebate-program"
    },
    {
      "key": "alberta",
      "location": "Alberta",
      "name": "Canadian Federal Tax Incentives",
      "link": "https://www.canada.ca/en/revenue-agency/services/tax/technical-information/income-tax/income-tax-folios-index/series-3-property-investments-savings-plans/series-3-property-investments-savings-plan-folio-8-resource-properties/income-tax-folio-s3-f8-c2-tax-incentives-clean-energy-equipment.html"
    },
    {
      "key": "alberta",
      "location": "Alberta",
      "name": "Edmonton Tax Incentive",
      "link": "https://www.edmonton.ca/city_government/environmental_stewardship/solar-energy.aspx"
    },
    {
      "key": "alberta",
      "location": "Alberta",
      "name": "Solar School Program",
      "link": "https://mccac.ca/programs/solar-for-schools-program/"
    },
    {
      "key": "alberta",
      "location": "Alberta",
      "name": "Farm Solar PV Program",
      "link": "https://www.alberta.ca/federal-agriculture-funding-programs-and-services-in-alberta.aspx"
    },
    {
      "key": "alberta",
      "location": "Alberta",
      "name": "Mincipal Solar Program",
      "link": "https://mccac.ca/programs/alberta-municipal-solar-program/"
    },
    {
      "key": "alberta",
      "location": "Alberta",
      "name": "Town of Banff Solar PV Program",
      "link": "https://banff.ca/807/Solar-Power"
    },
    {
      "key": "alberta",
      "location": "Alberta",
      "name": "Banff Solar Production Incentive",
      "link": "https://banff.ca/807/Solar-Power"
    },
    {
      "key": "new_brunswick",
      "location": "New Brunswick",
      "name": "Canadian Federal Tax Incentives",
      "link": "https://www.canada.ca/en/revenue-agency/services/tax/technical-information/income-tax/income-tax-folios-index/series-3-property-investments-savings-plans/series-3-property-investments-savings-plan-folio-8-resource-properties/income-tax-folio-s3-f8-c2-tax-incentives-clean-energy-equipment.html"
    },
    {
      "key": "new_brunswick",
      "location": "New Brunswick",
      "name": "Commercial Building Retrofit Program",
      "link": "https://www.saveenergynb.ca/en/save-energy/commercial/commercial-buildings-retrofit-program/"
    },
    {
      "key": "new_brunswick",
      "location": "New Brunswick",
      "name": "Energy Management Incentive (EMIS)",
      "link": "https://www.saveenergynb.ca/en/save-energy/industrial/large-industry/"
    },
    {
      "key": "nova_scotia_",
      "location": "Nova Scotia",
      "name": "Canadian Federal Tax Incentives",
      "link": "https://www.canada.ca/en/revenue-agency/services/tax/technical-information/income-tax/income-tax-folios-index/series-3-property-investments-savings-plans/series-3-property-investments-savings-plan-folio-8-resource-properties/income-tax-folio-s3-f8-c2-tax-incentives-clean-energy-equipment.html"
    },
    {
      "key": "nova_scotia_",
      "location": "Nova Scotia",
      "name": "Solar Homes Program",
      "link": "https://www.efficiencyns.ca/residential/programs-services/solar-homes/"
    },
    {
      "key": "nunavut",
      "location": "Nunavut",
      "name": "Canadian Federal Tax Incentives",
      "link": "https://www.canada.ca/en/revenue-agency/services/tax/technical-information/income-tax/income-tax-folios-index/series-3-property-investments-savings-plans/series-3-property-investments-savings-plan-folio-8-resource-properties/income-tax-folio-s3-f8-c2-tax-incentives-clean-energy-equipment.html"
    },
    {
      "key": "quebec",
      "location": "Quebec",
      "name": "Canadian Federal Tax Incentives",
      "link": "https://www.canada.ca/en/revenue-agency/services/tax/technical-information/income-tax/income-tax-folios-index/series-3-property-investments-savings-plans/series-3-property-investments-savings-plan-folio-8-resource-properties/income-tax-folio-s3-f8-c2-tax-incentives-clean-energy-equipment.html"
    },
    {
      "key": "quebec",
      "location": "Quebec",
      "name": "Novoclimat",
      "link": "https://transitionenergetique.gouv.qc.ca/en/residential/programs/novoclimat/novoclimat-big-multiple-unit-buildings"
    },
    {
      "key": "quebec",
      "location": "Quebec",
      "name": "ÉcoPerformance",
      "link": "https://transitionenergetique.gouv.qc.ca/en/affaires/programmes/ecoperformance"
    },
    {
      "key": "quebec",
      "location": "Quebec",
      "name": "Construction Grant",
      "link": "https://fcm.ca/en/funding/gmf/capital-project-new-construction-energy-efficient-facilities"
    },
    {
      "key": "ontario",
      "location": "Ontario",
      "name": "Canadian Federal Tax Incentives",
      "link": "https://www.canada.ca/en/revenue-agency/services/tax/technical-information/income-tax/income-tax-folios-index/series-3-property-investments-savings-plans/series-3-property-investments-savings-plan-folio-8-resource-properties/income-tax-folio-s3-f8-c2-tax-incentives-clean-energy-equipment.html"
    },
    {
      "key": "ontario",
      "location": "Ontario",
      "name": "Commercial Custom Retrofit Program",
      "link": "https://enbridgesmartsavings.com/business-energy-management/programs-and-campaigns/commercial-custom-retrofit-program"
    },
    {
      "key": "ontario",
      "location": "Ontario",
      "name": "Equipment & Process Optimization",
      "link": "https://www.uniongas.com/business/save-money-and-energy/engineering-projects/equipment-process-optimization"
    },
    {
      "key": "saskatchewan",
      "location": "Saskatchewan",
      "name": "Canadian Federal Tax Incentives",
      "link": "https://www.canada.ca/en/revenue-agency/services/tax/technical-information/income-tax/income-tax-folios-index/series-3-property-investments-savings-plans/series-3-property-investments-savings-plan-folio-8-resource-properties/income-tax-folio-s3-f8-c2-tax-incentives-clean-energy-equipment.html"
    },
    {
      "key": "saskatchewan",
      "location": "Saskatchewan",
      "name": "Industrial Energy Optimization Program",
      "link": "https://www.saskpower.com/Efficiency-Programs-and-Tips/Saving-Power-At-Work/Savings-Programs/Business-Programs/Industrial-Energy-Optimization-Program"
    },
    {
      "key": "saskatchewan",
      "location": "Saskatchewan",
      "name": "Demand Response Program",
      "link": "https://www.saskpower.com/Efficiency-Programs-and-Tips/Saving-Power-At-Work/Savings-Programs/Business-Programs/Demand-Response-Program"
    },
    {
      "key": "saskatchewan",
      "location": "Saskatchewan",
      "name": "Net Metering",
      "link": "https://www.saskatchewan.ca/residents/environment-public-health-and-safety/green-living/net-metering"
    },
    {
      "key": "newfoundland_and_labrador_",
      "location": "Newfoundland and Labrador",
      "name": "Canadian Federal Tax Incentives",
      "link": "https://www.canada.ca/en/revenue-agency/services/tax/technical-information/income-tax/income-tax-folios-index/series-3-property-investments-savings-plans/series-3-property-investments-savings-plan-folio-8-resource-properties/income-tax-folio-s3-f8-c2-tax-incentives-clean-energy-equipment.html"
    },
    {
      "key": "newfoundland_and_labrador_",
      "location": "Newfoundland and Labrador",
      "name": "Solar Electric Rebate Program",
      "link": "https://www.newfoundlandpower.com/en/Business-Services/Rates-and-Services/Rebates"
    },
    {
      "key": "british_columbia_",
      "location": "British Columbia",
      "name": "Canadian Federal Tax Incentives",
      "link": "https://www.canada.ca/en/revenue-agency/services/tax/technical-information/income-tax/income-tax-folios-index/series-3-property-investments-savings-plans/series-3-property-investments-savings-plan-folio-8-resource-properties/income-tax-folio-s3-f8-c2-tax-incentives-clean-energy-equipment.html"
    },
    {
      "key": "british_columbia_",
      "location": "British Columbia",
      "name": "Better Buildings BC Program",
      "link": "https://betterbuildingsbc.ca/new-construction/net-zero-energy-ready-challenge/"
    },
    {
      "key": "british_columbia_",
      "location": "British Columbia",
      "name": "PST Tax Exemption",
      "link": "https://www2.gov.bc.ca/gov/content/taxes/sales-taxes/pst"
    },
    {
      "key": "british_columbia_",
      "location": "British Columbia",
      "name": "Transmission project incentives",
      "link": "https://www.bchydro.com/powersmart/business/programs/project-incentives/transmission.html"
    },
    {
      "key": "british_columbia_",
      "location": "British Columbia",
      "name": "Plant Design Incentives Program",
      "link": "https://www.bchydro.com/powersmart/business/programs/npd.html"
    },
    {
      "key": "british_columbia_",
      "location": "British Columbia",
      "name": "Distribution Project Incentive",
      "link": "https://www.bchydro.com/powersmart/business/programs/project-incentives/distribution.html"
    },
    {
      "key": "yukon",
      "location": "Yukon",
      "name": "Canadian Federal Tax Incentives",
      "link": "https://www.canada.ca/en/revenue-agency/services/tax/technical-information/income-tax/income-tax-folios-index/series-3-property-investments-savings-plans/series-3-property-investments-savings-plan-folio-8-resource-properties/income-tax-folio-s3-f8-c2-tax-incentives-clean-energy-equipment.html"
    },
    {
      "key": "yukon",
      "location": "Yukon",
      "name": "Commerical & Industrial Energy Rebate",
      "link": "https://yukon.ca/en/commercial-institutional-energy-rebates#standard-energy-upgrades"
    },
    {
      "key": "manitoba",
      "location": "Manitoba",
      "name": "Canadian Federal Tax Incentives",
      "link": "https://www.canada.ca/en/revenue-agency/services/tax/technical-information/income-tax/income-tax-folios-index/series-3-property-investments-savings-plans/series-3-property-investments-savings-plan-folio-8-resource-properties/income-tax-folio-s3-f8-c2-tax-incentives-clean-energy-equipment.html"
    },
    {
      "key": "manitoba",
      "location": "Manitoba",
      "name": "Energy Finance Program",
      "link": "https://www.hydro.mb.ca/your_home/loans_financing/energy_finance_plan/"
    },
    {
      "key": "manitoba",
      "location": "Manitoba",
      "name": "New Buildings Program 2.2",
      "link": "https://efficiencymb.ca/business/new-buildings/"
    },
    {
      "key": "northwest_territories",
      "location": "Northwest Territories",
      "name": "Canadian Federal Tax Incentives",
      "link": "https://www.canada.ca/en/revenue-agency/services/tax/technical-information/income-tax/income-tax-folios-index/series-3-property-investments-savings-plans/series-3-property-investments-savings-plan-folio-8-resource-properties/income-tax-folio-s3-f8-c2-tax-incentives-clean-energy-equipment.html"
    },
    {
      "key": "northwest_territories",
      "location": "Northwest Territories",
      "name": "AEA Rebates on Renewable Energy Products",
      "link": "http://aea.nt.ca/programs/energy-efficiency-incentive-program"
    },
    {
      "key": "northwest_territories",
      "location": "Northwest Territories",
      "name": "Alternative Energy Technologies Program",
      "link": "http://aea.nt.ca/programs/alternative-energy-technologies-program"
    },
    {
      "key": "alabama",
      "location": "Alabama",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "alaska",
      "location": "Alaska",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "alaska",
      "location": "Alaska",
      "name": "Net Metering",
      "link": "https://www.nrel.gov/solar/rps/ak.html"
    },
    {
      "key": "arizona",
      "location": "Arizona",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "arizona",
      "location": "Arizona",
      "name": "Solar Equipment Sales Tax Exemption",
      "link": "https://azdor.gov/forms/tpt-forms"
    },
    {
      "key": "arizona",
      "location": "Arizona",
      "name": "Renewable Energy Corporate Production Tax Credit",
      "link": "https://azdor.gov/forms/collections-forms/tax-clearance-application"
    },
    {
      "key": "arkansas",
      "location": "Arkansas",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "arkansas",
      "location": "Arkansas",
      "name": "Net Metering",
      "link": "https://www.entergy-arkansas.com/net_metering/"
    },
    {
      "key": "california",
      "location": "California",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "california",
      "location": "California",
      "name": "California: Net Energy Metering (NEM 2.0)",
      "link": "https://www.cpuc.ca.gov/general.aspx?id=3800"
    },
    {
      "key": "california",
      "location": "California",
      "name": "California Property Assessed Clean Energy Programs",
      "link": "https://www.energy.gov/eere/slsc/property-assessed-clean-energy-programs"
    },
    {
      "key": "colorado",
      "location": "Colorado",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "colorado",
      "location": "Colorado",
      "name": "Solar Equipment Sales and Tax Exemption",
      "link": "https://www.colorado.gov/tax/fyi-publications-income-tax"
    },
    {
      "key": "colorado",
      "location": "Colorado",
      "name": "Net Metering",
      "link": "https://www.nrel.gov/solar/rps/co.html"
    },
    {
      "key": "connecticut",
      "location": "Connecticut",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "connecticut",
      "location": "Connecticut",
      "name": "Net Metering",
      "link": "https://www.energizect.com/your-town/solutions-list/virtual-net-metering"
    },
    {
      "key": "connecticut",
      "location": "Connecticut",
      "name": "Solar Property Tax Exemption",
      "link": "https://www.cga.ct.gov/2013/rpt/2013-R-0341.htm"
    },
    {
      "key": "connecticut",
      "location": "Connecticut",
      "name": "Solar Equipment Sales and Tax Exemption",
      "link": "https://portal.ct.gov/DRS/Publications/Special-Notices/2010/SN-2010-9-1"
    },
    {
      "key": "delaware",
      "location": "Delaware",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "delaware",
      "location": "Delaware",
      "name": "Net Metering",
      "link": "https://www.delmarva.com/SmartEnergy/MyGreenPowerConnection/Pages/HowToApply.aspx"
    },
    {
      "key": "delaware",
      "location": "Delaware",
      "name": "Green Grant Delaware",
      "link": "https://greengrantdelaware.com/green-energy-delmarva/"
    },
    {
      "key": "florida",
      "location": "Florida",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "florida",
      "location": "Florida",
      "name": "Net Metering",
      "link": "https://www.fpl.com/clean-energy/net-metering.html"
    },
    {
      "key": "florida",
      "location": "Florida",
      "name": "City of Longwood Solar Rebate",
      "link": "https://www.longwoodfl.org/172/Raising-Energy-Efficiency-Program-REEP"
    },
    {
      "key": "florida",
      "location": "Florida",
      "name": "Solar Property Tax Exemption",
      "link": "https://www.coj.net/departments/property-appraiser/exemptions/required-documentation-for-homestead-exemption-app"
    },
    {
      "key": "florida",
      "location": "Florida",
      "name": "Solar Equipment Sales and Tax Exemption",
      "link": "https://floridarevenue.com/taxes/businesses/Pages/sales_cex.aspx"
    },
    {
      "key": "georgia",
      "location": "Georgia",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "georgia",
      "location": "Georgia",
      "name": "GreyStone Power Solar Rebate",
      "link": "https://www.greystonepower.com/solarphotovoltaicprogram"
    },
    {
      "key": "hawaii",
      "location": "Hawaii",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "hawaii",
      "location": "Hawaii",
      "name": "Solar Property Tax Exemption",
      "link": "https://energy.hawaii.gov/developer-investor/financing-and-incentives-for-renewable-energy-projects/state-of-hawaii-and-federal-incentives"
    },
    {
      "key": "hawaii",
      "location": "Hawaii",
      "name": "Renewable Energy Income Tax Credit",
      "link": "https://tax.hawaii.gov/geninfo/renewable/"
    },
    {
      "key": "idaho",
      "location": "Idaho",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "idaho",
      "location": "Idaho",
      "name": "Solar Property Tax Exemption",
      "link": "https://adacounty.id.gov/assessor/administration/homeowners-exemption/#:~:text=You%20must%20complete%20an%20application,also%20be%20filled%20out%20online"
    },
    {
      "key": "illinois",
      "location": "Illinois",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "illinois",
      "location": "Illinois",
      "name": "Adjustable Block Program",
      "link": "https://illinoisabp.com/dashboard-home-2/"
    },
    {
      "key": "illinois",
      "location": "Illinois",
      "name": "Net Metering",
      "link": "https://illinoisattorneygeneral.gov/environment/netmetering.html"
    },
    {
      "key": "illinois",
      "location": "Illinois",
      "name": "ComEd commercial solar rebates",
      "link": "https://www.comed.com/News/Pages/NewsReleases/2018_12_11.aspx"
    },
    {
      "key": "illinois",
      "location": "Illinois",
      "name": "Solar Property Tax Exemption",
      "link": "https://illinoissolar.org/blog/1005734"
    },
    {
      "key": "indiana",
      "location": "Indiana",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "indiana",
      "location": "Indiana",
      "name": "Solar Property Tax Exemption",
      "link": "https://www.in.gov/oed/2379.htm"
    },
    {
      "key": "indiana",
      "location": "Indiana",
      "name": "Solar Equipment Sales and Tax Exemption",
      "link": "https://www.in.gov/oed/2379.htm"
    },
    {
      "key": "iowa",
      "location": "Iowa",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "iowa",
      "location": "Iowa",
      "name": "Solar Property Tax Exemption",
      "link": "https://tax.iowa.gov/forms/data-center-business-application-property-tax-exemption-54-009"
    },
    {
      "key": "iowa",
      "location": "Iowa",
      "name": "Solar Energy Tax Incentive",
      "link": "https://programs-taxcredit.iowa.gov/Solar/Dashboard/External"
    },
    {
      "key": "kansas",
      "location": "Kansas",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "kansas",
      "location": "Kansas",
      "name": "Solar Property Tax Exemption",
      "link": "http://kslegislature.org/li/b2019_20/statute/079_000_0000_chapter/079_002_0000_article/"
    },
    {
      "key": "kentucky",
      "location": "Kentucky",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "louisiana",
      "location": "Louisiana",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "louisiana",
      "location": "Louisiana",
      "name": "Solar Equipment Sales and Tax Exemption",
      "link": "https://revenue.louisiana.gov/Individuals/SolarCredit"
    },
    {
      "key": "maine",
      "location": "Maine",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "maine",
      "location": "Maine",
      "name": "Net Metering",
      "link": "https://www.maine.gov/mpuc/electricity/renewables/neb/index.shtml"
    },
    {
      "key": "maryland",
      "location": "Maryland",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "maryland",
      "location": "Maryland",
      "name": "Commercial Clean Energy Rebate Program",
      "link": "https://energy.maryland.gov/business/pages/incentives/cleanenergygrants.aspx"
    },
    {
      "key": "maryland",
      "location": "Maryland",
      "name": "Net Metering",
      "link": "https://www.psc.state.md.us/electricity/the-electricity-division/community-net-metering/"
    },
    {
      "key": "maryland",
      "location": "Maryland",
      "name": "Solar Property Tax Exemption",
      "link": "https://www.montgomerycountymd.gov/finance/taxes/tax_credit_exempt.html"
    },
    {
      "key": "maryland",
      "location": "Maryland",
      "name": "Solar Equipment Sales and Tax Exemption",
      "link": "https://www.marylandtaxes.gov/business/sales-use/tax-exemptions/index.php"
    },
    {
      "key": "massachusetts",
      "location": "Massachusetts",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "massachusetts",
      "location": "Massachusetts",
      "name": "Solar Massachusetts Renewable Target (SMART)",
      "link": "https://masmartsolar.com/"
    },
    {
      "key": "massachusetts",
      "location": "Massachusetts",
      "name": "Net Metering",
      "link": "http://www.massaca.org/general-net-metering.asp"
    },
    {
      "key": "massachusetts",
      "location": "Massachusetts",
      "name": "Solar Equipment Sales and Tax Exemption",
      "link": "https://www.mass.gov/guides/sales-and-use-tax"
    },
    {
      "key": "massachusetts",
      "location": "Massachusetts",
      "name": "Solar Property Tax Exemption",
      "link": "https://www.mass.gov/lists/property-tax-forms-and-guides"
    },
    {
      "key": "michigan",
      "location": "Michigan",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "michigan",
      "location": "Michigan",
      "name": "Solar Property Tax Exemption",
      "link": "http://www.legislature.mi.gov/(S(0rlioe2kedbgnx0dtuczkncy))/mileg.aspx?page=getObject&objectName=mcl-211-7h"
    },
    {
      "key": "minnesota",
      "location": "Minnesota",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "minnesota",
      "location": "Minnesota",
      "name": "Net Metering",
      "link": "https://mn.gov/puc/energy/distributed-energy/net-metering/"
    },
    {
      "key": "minnesota",
      "location": "Minnesota",
      "name": "Minnesota Power",
      "link": "https://www.mnpower.com/Environment/SolarSense/"
    },
    {
      "key": "minnesota",
      "location": "Minnesota",
      "name": "Solar Equipment Sales and Tax Exemption",
      "link": "https://mn.gov/commerce/media/news/?id=17-323969"
    },
    {
      "key": "minnesota",
      "location": "Minnesota",
      "name": "Solar Property Tax Exemption",
      "link": "https://www.otpco.com/ways-to-save/renewable-energy-residential/publicly-owned-property-solar/"
    },
    {
      "key": "mississippi",
      "location": "Mississippi",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "missouri",
      "location": "Missouri",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "missouri",
      "location": "Missouri",
      "name": "Net Metering",
      "link": "https://energy.mo.gov/solar/net-metering"
    },
    {
      "key": "missouri",
      "location": "Missouri",
      "name": "Columbia Solar Rebates",
      "link": "http://www.columbiapowerpartners.com/solar/"
    },
    {
      "key": "missouri",
      "location": "Missouri",
      "name": "Solar Property Tax Exemption",
      "link": "https://stc.mo.gov/"
    },
    {
      "key": "montana",
      "location": "Montana",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "montana",
      "location": "Montana",
      "name": "Solar Property Tax Exemption",
      "link": "http://deq.mt.gov/Energy/taxincentrenew#15-6-225"
    },
    {
      "key": "montana",
      "location": "Montana",
      "name": "Solar Equipment Sales and Tax Exemption",
      "link": "http://deq.mt.gov/Energy/taxincentrenew#nonfossilgeneration"
    },
    {
      "key": "montana",
      "location": "Montana",
      "name": "Net Metering",
      "link": "https://deq.mt.gov/Energy/renewableenergy/netmeterrenew"
    },
    {
      "key": "nebraska",
      "location": "Nebraska",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "nebraska",
      "location": "Nebraska",
      "name": "Solar Property Tax Exemption",
      "link": "https://revenue.nebraska.gov/PAD/homestead-exemption"
    },
    {
      "key": "nevada",
      "location": "Nevada",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "nevada",
      "location": "Nevada",
      "name": "Net Metering",
      "link": "http://puc.nv.gov/Renewable_Energy/Net_Metering/"
    },
    {
      "key": "nevada",
      "location": "Nevada",
      "name": "Large Scale Renewable Energy Property Tax Abatement",
      "link": "https://energy.nv.gov/Programs/Renewable_Energy_Tax_Abatements/"
    },
    {
      "key": "new_hampshire",
      "location": "New Hampshire",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "new_hampshire",
      "location": "New Hampshire",
      "name": "Commercial & Industrial Solar Incentive Program",
      "link": "https://www.puc.nh.gov/Sustainable%20Energy/RenewableEnergyRebates-CI.html"
    },
    {
      "key": "new_hampshire",
      "location": "New Hampshire",
      "name": "Solar Property Tax Exemption",
      "link": "https://www.nh.gov/osi/energy/saving-energy/incentives.htm"
    },
    {
      "key": "new_jersey",
      "location": "New Jersey",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "new_jersey",
      "location": "New Jersey",
      "name": "Net Metering",
      "link": "https://www.njcleanenergy.com/renewable-energy/programs/net-metering-and-interconnection"
    },
    {
      "key": "new_jersey",
      "location": "New Jersey",
      "name": "Solar Equipment Sales and Tax Exemption",
      "link": "https://www.state.nj.us/treasury/taxation/lpt/lpt-abatements.shtml"
    },
    {
      "key": "new_jersey",
      "location": "New Jersey",
      "name": "Solar Property Tax Exemption",
      "link": "https://www.state.nj.us/treasury/taxation/lpt/lpt-abatements.shtml"
    },
    {
      "key": "new_mexico",
      "location": "New Mexico",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "new_mexico",
      "location": "New Mexico",
      "name": "Net Metering",
      "link": "https://www.pnm.com/solar"
    },
    {
      "key": "new_mexico",
      "location": "New Mexico",
      "name": "Solar Property Tax Exemption",
      "link": "http://www.emnrd.state.nm.us/ecmd/CleanEnergyTaxIncentives/SolarGrossReceiptsExemption.html"
    },
    {
      "key": "new_mexico",
      "location": "New Mexico",
      "name": "Solar Equipment Sales and Tax Exemption",
      "link": "http://www.emnrd.state.nm.us/ecmd/CleanEnergyTaxIncentives/SolarGrossReceiptsExemption.html"
    },
    {
      "key": "new_york",
      "location": "New York",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "new_york",
      "location": "New York",
      "name": "Net Metering",
      "link": "https://www.nyserda.ny.gov/Researchers-and-Policymakers/Power-Generation/Net-Metering-Interconnection"
    },
    {
      "key": "new_york",
      "location": "New York",
      "name": "Solar Property Tax Exemption",
      "link": "https://www.tax.ny.gov/pubs_and_bulls/publications/sales/st_pubs_and_bulls_by_number.htm"
    },
    {
      "key": "new_york",
      "location": "New York",
      "name": "Solar Equipment Sales and Tax Exemption",
      "link": "https://www.tax.ny.gov/pubs_and_bulls/publications/sales/st_pubs_and_bulls_by_number.htm"
    },
    {
      "key": "new_york",
      "location": "New York",
      "name": "Sun PV Incentive Program",
      "link": "https://portal.nyserda.ny.gov/CORE_Solicitation_Detail_Page?SolicitationId=a0rt0000000QnxFAAS"
    },
    {
      "key": "new_york",
      "location": "New York",
      "name": "Solar Energy System Equipment Credit",
      "link": "https://www.tax.ny.gov/pit/credits/solar_energy_system_equipment_credit.htm#:~:text=The%20credit%20is%20equal%20to,for%20up%20to%20five%20years."
    },
    {
      "key": "north_carolina",
      "location": "North Carolina",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "north_carolina",
      "location": "North Carolina",
      "name": "Net Metering",
      "link": "https://publicstaff.nc.gov/electric/net-metering#:~:text=How%20do%20I%20get%20started,to%20connect%20to%20their%20system."
    },
    {
      "key": "north_carolina",
      "location": "North Carolina",
      "name": "Solar Property Tax Exemption",
      "link": "https://www.ces.ncsu.edu/solar-generation-property-taxation/"
    },
    {
      "key": "north_carolina",
      "location": "North Carolina",
      "name": "Duke Energy Solar Rebate Program",
      "link": "https://www.duke-energy.com/home/products/renewable-energy/nc-solar-rebates?jur=NC01"
    },
    {
      "key": "north_dakota",
      "location": "North Dakota",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "north_dakota",
      "location": "North Dakota",
      "name": "Solar Property Tax Exemption",
      "link": "https://www.nd.gov/tax/user/individuals/forms--publications/property-tax/forms--instructions"
    },
    {
      "key": "ohio",
      "location": "Ohio",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "ohio",
      "location": "Ohio",
      "name": "Net Metering",
      "link": "https://puco.ohio.gov/wps/portal/gov/puco/utilities/electricity/resources/major-application-requirements-for-distributed-generation-interconnection"
    },
    {
      "key": "ohio",
      "location": "Ohio",
      "name": "Solar Property Tax Exemption",
      "link": "https://development.ohio.gov/bs/bs_qepte.htm"
    },
    {
      "key": "ohio",
      "location": "Ohio",
      "name": "Solar Equipment Sales and Tax Exemption",
      "link": "https://development.ohio.gov/bs/bs_contaxexempt.htm"
    },
    {
      "key": "oklahoma",
      "location": "Oklahoma",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "oregon",
      "location": "Oregon",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "oregon",
      "location": "Oregon",
      "name": "Energy Trust",
      "link": "https://www.energytrust.org/residential/forms/"
    },
    {
      "key": "oregon",
      "location": "Oregon",
      "name": "Net Metering",
      "link": "http://solaroregon.org/resources/becoming-a-northwest-solar-community-2/interconnection-and-net-metering/"
    },
    {
      "key": "oregon",
      "location": "Oregon",
      "name": "Solar Property Tax Exemption",
      "link": "https://www.oregon.gov/energy/Incentives/Pages/default.aspx"
    },
    {
      "key": "pennsylvania",
      "location": "Pennsylvania",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "pennsylvania",
      "location": "Pennsylvania",
      "name": "Solar Rebate",
      "link": "https://www.phila.gov/programs/solar-rebate-program/"
    },
    {
      "key": "pennsylvania",
      "location": "Pennsylvania",
      "name": "Net Metering",
      "link": "https://www.puc.pa.gov/filing-resources/issues-laws-regulations/aeps-act/"
    },
    {
      "key": "rhode_island",
      "location": "Rhode Island",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "rhode_island",
      "location": "Rhode Island",
      "name": "Net Metering",
      "link": "http://www.energy.ri.gov/policies-programs/programs-incentives/net-metering.php"
    },
    {
      "key": "rhode_island",
      "location": "Rhode Island",
      "name": "Solar Property Tax Exemption",
      "link": "http://www.energy.ri.gov/policies-programs/programs-incentives/"
    },
    {
      "key": "rhode_island",
      "location": "Rhode Island",
      "name": "Solar Equipment Sales and Tax Exemption",
      "link": "http://www.energy.ri.gov/policies-programs/programs-incentives/"
    },
    {
      "key": "rhode_island",
      "location": "Rhode Island",
      "name": "Solar Renewable Energy Fund",
      "link": "https://commerceri.com/financing/renewable-energy-fund/"
    },
    {
      "key": "south_carolina",
      "location": "South Carolina",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "south_carolina",
      "location": "South Carolina",
      "name": "Net Metering",
      "link": "http://solar.sc.gov/netmetering"
    },
    {
      "key": "south_carolina",
      "location": "South Carolina",
      "name": "Duke Energy Rebate Program",
      "link": "https://www.duke-energy.com/our-company/environment/renewable-energy/solar-energy/sc-solar-energy-programs/solar-rebates?jur=SC01"
    },
    {
      "key": "south_carolina",
      "location": "South Carolina",
      "name": "Solar Panel Tax Credit",
      "link": "http://www.energy.sc.gov/renewable"
    },
    {
      "key": "south_dakota",
      "location": "South Dakota",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "south_dakota",
      "location": "South Dakota",
      "name": "Solar Property Tax Exemption",
      "link": "https://puc.sd.gov/energyefficiency/"
    },
    {
      "key": "tennessee",
      "location": "Tennessee",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "tennessee",
      "location": "Tennessee",
      "name": "Solar Equipment Sales and Tax Exemption",
      "link": "https://www.tn.gov/revenue/taxes/sales-and-use-tax.html"
    },
    {
      "key": "texas",
      "location": "Texas",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "texas",
      "location": "Texas",
      "name": "Solar Property Tax Exemption",
      "link": "https://comptroller.texas.gov/taxes/property-tax/exemptions/"
    },
    {
      "key": "texas",
      "location": "Texas",
      "name": "Solar Equipment Sales and Tax Exemption",
      "link": "https://www.tn.gov/revenue/taxes/sales-and-use-tax.html"
    },
    {
      "key": "texas",
      "location": "Texas",
      "name": "SMART Source Solar PV Program",
      "link": "http://www.txreincentives.com/apv/index.php"
    },
    {
      "key": "utah",
      "location": "Utah",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "utah",
      "location": "Utah",
      "name": "Investment Tax Credit",
      "link": "https://rules.utah.gov/publicat/code/r362/r362-002.htm#T5"
    },
    {
      "key": "vermont",
      "location": "Vermont",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "vermont",
      "location": "Vermont",
      "name": "Net Metering",
      "link": "https://puc.vermont.gov/electric/net-metering"
    },
    {
      "key": "vermont",
      "location": "Vermont",
      "name": "Solar Property Tax Exemption",
      "link": "https://tax.vermont.gov/municipal-officials/solar-plant-taxation"
    },
    {
      "key": "vermont",
      "location": "Vermont",
      "name": "Solar Equipment Sales and Tax Exemption",
      "link": "https://tax.vermont.gov/municipal-officials/solar-plant-taxation"
    },
    {
      "key": "virginia",
      "location": "Virginia",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "virginia",
      "location": "Virginia",
      "name": "Net Metering",
      "link": "https://www.mycvec.com/energy-solutions/net-metering"
    },
    {
      "key": "virginia",
      "location": "Virginia",
      "name": "Solar Property Tax Exemption",
      "link": "https://www.dmme.virginia.gov/DE/Energy_Incentives.shtml"
    },
    {
      "key": "washington",
      "location": "Washington",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "washington",
      "location": "Washington",
      "name": "Solar Equipment Sales and Tax Exemption",
      "link": "https://dor.wa.gov/content/solar-energy-system-sales-tax-exemption-refund"
    },
    {
      "key": "washington",
      "location": "Washington",
      "name": "Net Metering",
      "link": "https://www.utc.wa.gov/regulatedIndustries/utilities/energy/Pages/netMetering.aspx"
    },
    {
      "key": "west_virginia",
      "location": "West Virginia",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "west_virginia",
      "location": "West Virginia",
      "name": "Net Metering",
      "link": "http://www.wvlegislature.gov/WVCODE/ChapterEntire.cfm?chap=24&art=2F&section=8"
    },
    {
      "key": "wisconsin",
      "location": "Wisconsin",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "wisconsin",
      "location": "Wisconsin",
      "name": "Solar Power Rebate",
      "link": "https://www.renewwisconsin.org/solar-energy/"
    },
    {
      "key": "wisconsin",
      "location": "Wisconsin",
      "name": "Solar Equipment Sales and Tax Exemption",
      "link": "https://www.revenue.wi.gov/Pages/FAQS/pcs-s-exempt.aspx"
    },
    {
      "key": "wisconsin",
      "location": "Wisconsin",
      "name": "Solar Property Tax Exemption",
      "link": "https://www.revenue.wi.gov/Pages/Businesses/incentives-finder.aspx"
    },
    {
      "key": "wyoming",
      "location": "Wyoming",
      "name": "Solar Investment Tax Credit (ITC)",
      "link": "https://www.energy.gov/eere/solar/downloads/residential-and-commercial-itc-factsheets"
    },
    {
      "key": "wyoming",
      "location": "Wyoming",
      "name": "Net Metering",
      "link": "https://psc.wyo.gov/"
    }
  ]
}